(() => {
  document.querySelectorAll('[data-sort-form] select').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  document.querySelectorAll('.hb-menu').forEach(menu => {
    menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.querySelectorAll('[data-cookie-preferences]').forEach(button => button.addEventListener('click', async () => {
    const status = document.querySelector('[data-cookie-status]');
    try {
      if (!window.privacyBanner?.showPreferences) throw new Error('unavailable');
      await window.privacyBanner.showPreferences();
      if (status) status.textContent = '';
    } catch (_) {
      if (status) status.textContent = 'Preferințele nu s-au încărcat. Reîncarcă pagina și încearcă din nou.';
    }
  }));
  document.querySelectorAll('[data-cart-form]').forEach(form => {
    form.addEventListener('submit', event => {
      if (event.submitter?.name === 'checkout') {
        event.submitter.setAttribute('aria-busy','true');
        event.submitter.textContent = 'Se deschide checkout-ul…';
      }
    });
  });
})();
